import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-allcontest',
  templateUrl: './allcontest.component.html',
  styleUrls: ['./allcontest.component.css'],
})
export class AllcontestComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}
  filmPage() {
    this.router.navigate(['/contest/film'])
  }
}
